import { render, staticRenderFns } from "./RolePopup.vue?vue&type=template&id=7d6583da"
import script from "./RolePopup.vue?vue&type=script&lang=js"
export * from "./RolePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports